import { render, staticRenderFns } from "./PersonalDetailsSkeleton.vue?vue&type=template&id=20a17dfe&scoped=true&"
import script from "./PersonalDetailsSkeleton.vue?vue&type=script&lang=js&"
export * from "./PersonalDetailsSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDetailsSkeleton.vue?vue&type=style&index=0&id=20a17dfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a17dfe",
  null
  
)

export default component.exports